import React, { useState, useEffect } from 'react';
import './index.scss';
import {
  statsRetentionLifetime,
  countryRetentionLifetime,
} from '@/pages/intelligence/services/topcharts';
import RetentionCurveCard from './components/RetentionCurveCard';
import CountriesCard from './components/CountriesCard';
import { DownloadTitleTips } from '../_config';
import ExportTable from '../../../../../../../components/ExportTable';
import moment from 'moment';
import {
  URL_ORDER,
  URL_SORT_NAME,
  updateShortLinkPath,
  updateShortLinkFilterId,
  URL_FILTER_KEY,
  URL_APP_IDS,
} from '@intelligence/utils/urlPathCfg';
import {
  hasShortLinkRatio,
  statsLifetimeRetentionValidCfg,
  getStatsRetentionValidUrlParams,
} from '@intelligence/_config/urlPageValidCfg';
import { useShortLink } from '@intelligence/hooks/useShortLink';
import { mobileStats } from '@intelligence/v3/constants/downloadLogPoint';

const RetentionCurve = (props: any) => {
  const {
    isBasicLoading,
    loading,
    setLoading,
    isCalibrated,
    tabType,
    pageId /** activeusers  revenue downloads*/,
    basicInfo,
    appIdListAll,
    unPublishedAppIdList,
    gameId,
    appIds,
    entityType,
  } = props;

  const isCoutriesPage = tabType === 'countries';
  const [countryTableData, setCountryTableData] = useState<any[]>([]);
  const [countryLineData, setCountryLineData] = useState<any>([]);
  const [statsLoading, setStatsLoading] = useState(true);
  const [countryLoading, setCountryLoading] = useState(true);
  const [statsError, setStatsError] = useState(true);
  const [countryError, setCountryError] = useState(true);
  const [statsResData, setStatsResData] = useState<any[]>([]);
  const hasUrlShortLink = isCoutriesPage
    ? hasShortLinkRatio?.detailMobileCountriesRetentionLifetime
    : hasShortLinkRatio?.detailMobileStatsRetentionLifetime;

  const { initShortLinkCfgNoAwait, shortLinkValidQuery } = useShortLink({
    hasUrlShortLink,
    getPageValidCfg: () => statsLifetimeRetentionValidCfg,
    getCustomValidUrlParams: getStatsRetentionValidUrlParams,
  });

  useEffect(() => {
    // 进入页面时判断是否有tokenQuery等，有则进入
    initShortLinkCfgNoAwait();
  }, []);

  const defaultSortDownHead = 'D2';
  const [fetchParams, setApiData] = useState({
    app_ids: appIds,
    metrics: [
      // 'D1',
      'D90',
      'D60',
      'D30',
      'D14',
      'D7',
      'D6',
      'D5',
      'D4',
      'D3',
      'D2',
    ],
  });

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading) {
      setLoading(true);
    } else {
      getPageData();
      if (hasUrlShortLink) {
        updateShortLinkFilterId({ [URL_FILTER_KEY]: {}, [URL_APP_IDS]: appIds });
      }
    }
    // (Stats与Countries切换继承需要唤醒父父父组件的更新)
    // dispatch({ type: 'topcharts/setIsOperation', payload: topcharts.isOperation });
  }, [isBasicLoading]);

  const getPageData = () => {
    if (tabType === 'stats') {
      getStatsLifeTimeData();
    } else if (isCoutriesPage) {
      getCountryLifeTimeData();
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  const getStatsLifeTimeData = async () => {
    const newFetchParams = { ...fetchParams };
    newFetchParams.app_ids = appIds;
    setApiData(newFetchParams);
    setStatsLoading(true);
    // eslint-disable-next-line no-prototype-builtins
    if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
      setStatsResData([]);
      setLoading(false);
      setStatsLoading(false);
      return;
    }
    const res = await statsRetentionLifetime(newFetchParams);
    try {
      if (res?.code === 0 && res?.data?.length !== 0) {
        // setReqParamsDownLoad({
        //   ...newFetchParams,
        //   start_date: res?.req?.start_date,
        //   end_date: res?.req?.end_date,
        // })
        const dataList = res?.data;
        // 从basicinfo接口中提取头像和platform
        const newDataList: any[] = [];

        dataList?.forEach((item) => {
          const appIdItem = appIdListAll?.filter((obj) => {
            return obj?.id === item.app_id;
          });
          newDataList.push(Object.assign(item, ...appIdItem));
        });
        setStatsResData(newDataList);
      } else {
        // setStatsTableData([]);
        setStatsResData([]);
      }
      setStatsError(false);
    } catch (err) {
      setStatsError(true);
      // setStatsTableData([]);
      setStatsResData([]);
    }
    setLoading(false);
    setStatsLoading(false);
  };

  const getCountryLifeTimeData = async () => {
    const newFetchParams = { ...fetchParams };
    newFetchParams.app_ids = appIds;
    setApiData(newFetchParams);
    setCountryLoading(true);
    // eslint-disable-next-line no-prototype-builtins
    if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
      setCountryTableData([]);
      setCountryLineData([]);
      setCountryLoading(false);
      setLoading(false);
      return;
    }

    const res = await countryRetentionLifetime(newFetchParams);
    try {
      if (res?.code === 0 && res?.data?.length !== 0) {
        setCountryTableData(res?.data);
        res.data[0].metrics = res?.data[0].metrics.filter((item: any) => item.value_per);
        setCountryLineData(res?.data);
      } else {
        setCountryTableData([]);
        setCountryLineData([]);
      }
      setCountryError(false);
    } catch (err) {
      setCountryError(true);
    }
    setCountryLoading(false);
    setLoading(false);
  };

  const [countriesPageSortAttr, setCountriesPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: shortLinkValidQuery?.[URL_ORDER] || 'D2',
    currentRatioType: 0,
  });

  const onTableSortChageEdition = (e) => {
    setCountriesPageSortAttr({
      // ...trendPageSortAttr,
      currentSortValue: e?.sortVal,
      currentSortMetric: e?.sortMetric,
      currentRatioType: e?.ratioType,
    });
  };

  useEffect(() => {
    if (hasUrlShortLink) {
      updateShortLinkPath({
        shortLinkQuery: {
          [URL_ORDER]: countriesPageSortAttr?.currentSortValue,
          [URL_SORT_NAME]: countriesPageSortAttr?.currentSortMetric,
        },
      });
    }
  }, [countriesPageSortAttr]);

  useEffect(() => {
    if (hasUrlShortLink) {
      setCountriesPageSortAttr?.({
        // ...trendPageSortAttr,
        currentSortValue:
          shortLinkValidQuery?.[URL_ORDER] || countriesPageSortAttr.currentSortValue,
        currentSortMetric:
          shortLinkValidQuery?.[URL_SORT_NAME] || countriesPageSortAttr.currentSortMetric,
        currentRatioType: 0,
      });
    }
  }, [shortLinkValidQuery]);

  return (
    <>
      <div className="stats-lifetime-downloadbtn">
        <ExportTable
          entityType="mobile"
          tableParams={{
            ...fetchParams,
            segment: pageId,
            unified_id: gameId,
            unified_ids: [gameId],
            entity_type: 'mobile',
            region_type: 'region',
            regions: ['global'],
            date_type: 'monthly',
            start_date: moment().subtract(6, 'month').startOf('month').format('YYYY-MM-DD'),
            end_date: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          }}
          downloadTitleTips={DownloadTitleTips}
          businessType="mobile-stats-retentionlifetime"
          isShowMaxDownloadRowsTips={false}
          isDisableDownload={loading}
          downloadModalSize={820}
          isDisableDataAmount={true}
          isCalibrated={isCalibrated}
          newStyleFileName={`${basicInfo?.name}${
            tabType === 'stats' ? '_Stats' : isCoutriesPage ? '_Countries' : ''
          }`}
          isCoutriesPage={isCoutriesPage}
          downloadLogConfigKey={mobileStats?.[`${tabType}_${pageId}`]}
        />
      </div>

      <div className="dbi-trends-card">
        {isCoutriesPage ? (
          <CountriesCard
            lineData={countryLineData}
            tableData={countryTableData}
            latestDay="2025-07-01"
            unPublishedAppIdList={unPublishedAppIdList}
            cardStatus={{
              isLoading: loading || countryLoading,
              isError: countryError,
              isNoData: !countryTableData?.length,
            }}
            entityType={entityType}
          />
        ) : (
          <RetentionCurveCard
            resData={statsResData}
            latestDay="2025-07-01"
            // lineData={statsLineData}
            // tableData={statsTableData}
            unPublishedAppIdList={unPublishedAppIdList}
            defaultSortDownHead={defaultSortDownHead}
            cardStatus={{
              isLoading: loading || statsLoading,
              isError: statsError,
              isNoData: !statsResData?.length,
            }}
            pageSortAttr={countriesPageSortAttr}
            onTableSortChage={onTableSortChageEdition}
            entityType={entityType}
          />
        )}
      </div>
    </>
  );
};

export default RetentionCurve;
